/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import React from 'react';
import { useFormikContext } from 'formik';

import { HelpBlock } from 'components/bootstrap';
import OperatorField from 'data-lake/preview/OperatorField';
import FieldFiltersConfiguration from 'data-lake/FieldFiltersConfiguration/FieldFiltersConfiguration';
import type { DataLakeActionFormValues } from 'data-lake/Types';
import StyledLabel from 'data-lake/components/DataLakeActionModals/StyledLabel';

const FieldsFiltersField = () => {
  const {
    values: { fieldFilters },
  } = useFormikContext<DataLakeActionFormValues>();

  return (
    <>
      <StyledLabel>Filter by fields</StyledLabel>
      <HelpBlock>Here you can add field filters.</HelpBlock>
      {!!fieldFilters.length && <OperatorField />}
      <FieldFiltersConfiguration maxFilters={3} />
    </>
  );
};

export default FieldsFiltersField;
